
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("btGRq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $042f8b74cf4f6d87$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $042f8b74cf4f6d87$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': "Optimis\xe9e par Atlassian\xa0Intelligence",
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': "Optimis\xe9 par AI",
    'fabric.editor.ai.commandPalette.footer.disclaimerText': "Le contenu est bas\xe9 sur vos autorisations, et sa qualit\xe9 peut varier",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': "La qualit\xe9 du contenu est susceptible de varier",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': "Utilise l'IA. V\xe9rifiez les r\xe9sultats.",
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informations',
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Inclure les connaissance de la page actuelle',
    'fabric.editor.ai.commandPalette.promptForm.logo': "Logo Atlassian\xa0Intelligence",
    'fabric.editor.ai.components.backIconButton.backLabel': 'Retour',
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Annuler',
    'fabric.editor.ai.components.cancelEscButton.escLabel': "\xc9chap",
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Annuler',
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Annuler',
    'fabric.editor.ai.components.feedbackForm.badResponse': "Mauvaise r\xe9ponse",
    'fabric.editor.ai.components.feedbackForm.feedbackSent': "Feedback envoy\xe9",
    'fabric.editor.ai.components.feedbackForm.goodResponse': "Bonne r\xe9ponse",
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': "Continuer \xe0 partir de la derni\xe8re r\xe9ponse",
    'fabric.editor.ai.config.item.action.copyResponse': 'Copier',
    'fabric.editor.ai.config.item.action.responseCopied': "Copi\xe9e\xa0!",
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': "Copi\xe9e dans le presse-papiers",
    'fabric.editor.ai.config.item.action.retryPrompt': "R\xe9essayer",
    'fabric.editor.ai.experience-application.documentInsertError': "Nous rencontrons un probl\xe8me pour ins\xe9rer la r\xe9ponse. Fermez la bo\xeete de dialogue et r\xe9essayez.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "Impossible d'obtenir une r\xe9ponse. Votre invite ou votre r\xe9ponse a d\xe9pass\xe9 la limite fix\xe9e pour cette demande. Fermez la bo\xeete de dialogue et r\xe9essayez.",
    'fabric.editor.ai.experience.apiError': "Impossible d'obtenir une r\xe9ponse, veuillez r\xe9essayer.",
    'fabric.editor.ai.experience.commandPaletteAriaName': "Atlassian\xa0Intelligence",
    'fabric.editor.ai.experience.inputTooShortError': "Le contenu est trop court pour \xeatre r\xe9sum\xe9. Veuillez ajouter du contenu, puis r\xe9essayez.",
    'fabric.editor.ai.experience.loadingAriaTitle': "G\xe9n\xe9ration",
    'fabric.editor.ai.experience.previewScreenLabel': "Pr\xe9visualiser",
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': "Demandez \xe0 l'agent d'\xe9crire quelque chose ou choisissez parmi les options ci-dessous",
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logo Rovo',
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': "Atlassian\xa0Intelligence",
    'fabric.editor.ai.screens.discard.cancelLabel': 'Retour',
    'fabric.editor.ai.screens.discard.discardLabel': 'Ignorer',
    'fabric.editor.ai.screens.error.warningIconLabel': 'Avertissement',
    'fabric.editor.ai.screens.error.ariaErrorTitle': 'Erreur',
    'fabric.editor.ai.screens.error.cancelLabel': 'Annuler',
    'fabric.editor.ai.screens.error.retryLabel': "R\xe9essayer",
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': "Contenu mis \xe0 jour en temps r\xe9el\xa0:",
    'fabric.editor.ai.screens.loading.iconAltText': "G\xe9n\xe9ration d'une ic\xf4ne",
    'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': "Actions pour le contenu g\xe9n\xe9r\xe9 par l'IA",
    'fabric.editor.ai.screens.preview.betaLabel': "B\xeata",
    'fabric.editor.ai.screens.preview.cancelLabel': 'Annuler',
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': "Dire \xe0 AI ce qu'il doit faire ensuite",
    'fabric.editor.ai.screens.preview.discardLabel': 'Ignorer',
    'fabric.editor.ai.screens.preview.disclaimer': "La qualit\xe9 des informations peut varier.",
    'fabric.editor.ai.screens.preview.disclaimerLink': "D\xe9couvrez pourquoi",
    'fabric.editor.ai.screens.preview.header.clear.hover': 'Effacer',
    'fabric.editor.ai.screens.preview.header.edit': "Modifier l'invite",
    'fabric.editor.ai.screens.preview.header.edit.hover': 'Modifier',
    'fabric.editor.ai.screens.preview.placeholderWithAgent': "Demander \xe0 {agentName} quoi faire ensuite",
    'fabric.editor.ai.screens.preview.refineButton': 'Affiner',
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Affiner',
    'fabric.editor.ai.screens.prompt.logoAltText': "Logo Atlassian\xa0Intelligence",
    'fabric.editor.ai.screens.prompt.logoText': "Atlassian\xa0Intelligence",
    'fabric.editor.ai.screens.prompt.submitLabel': 'Envoyer',
    'fabric.editor.ai.screens.prompt.submitTooltip': "Envoyer \xe0 AI",
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': "{promptName} - S\xe9lectionn\xe9",
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Supprimer',
    'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Suggestions',
    'fabric.editor.ai.shared.aiUniversalDescriptor': "Assistant de r\xe9daction",
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': "Laissez Atlassian\xa0Intelligence vous aider \xe0 \xe9crire",
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': "\xc9crire",
    'fabric.editor.ai.shared.betaLabel': "B\xeata",
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': "AI\xa0(Atlassian\xa0Intelligence)",
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': "B\xcaTA",
    'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOUVEAU',
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': "Dire \xe0 AI\xa0:",
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': "Dire \xe0 l'agent"
};

});


//# sourceMappingURL=fr.c22e5b44.js.map
